import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileAcceptFormat',
})
export class FileAcceptFormatPipe implements PipeTransform {
  transform(formats: string[]): string {
    return formats.length ? formats.map((item) => `${item}`).join(', ') : '';
  }
}
